import { createContext, useContext } from "react";
import { AuthMeResponse } from "../types/auth";

export type AuthorizedFetch = (
  path: string,
  init?: RequestInit,
) => Promise<Response>;

type AppSessionContextValue = {
  backendUrl: string;
  authorizedFetch: AuthorizedFetch;
  me: AuthMeResponse | null;
  meLoading: boolean;
  meError: string | null;
  canManageClientCompanies: boolean;
  canMaintainEmployees: boolean;
  canManageUsers: boolean;
};

const AppSessionContext = createContext<AppSessionContextValue | null>(null);

export const AppSessionProvider = AppSessionContext.Provider;

export const useAppSession = () => {
  const context = useContext(AppSessionContext);

  if (!context) {
    throw new Error("useAppSession must be used inside AppSessionProvider");
  }

  return context;
};
